import React from 'react';
import StrictMode from 'react';
import ReactDOM from 'react-dom/client';
import {PublicClientApplication} from '@azure/msal-browser';
import {MsalProvider} from '@azure/msal-react';
import {msalConfig} from './authConfig';
import MsalLoadingComponent from './components/MsalLoadingComponent';
import './scss/styles.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL instance and handle redirect promise
const initializeMsal = async () => {
  try {
    // Initialize the MSAL instance
    await msalInstance.initialize();
    console.log('MSAL instance initialized successfully');

    // Handle redirect promise after initialization
    const tokenResponse = await msalInstance.handleRedirectPromise();
    if (tokenResponse) {
      console.log('Login redirect successful:', tokenResponse.account);
    }

    // Render the app after MSAL is initialized
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    );
  } catch (error) {
    console.error('Error initializing MSAL:', error);
    // Still render the app but with error handling
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(
      <div style={{padding: '20px', textAlign: 'center'}}>
        <h3>Authentication Initialization Error</h3>
        <p>There was an error initializing the authentication system.</p>
        <p>Please refresh the page or contact support.</p>
        <details>
          <summary>Error Details</summary>
          <pre>{error instanceof Error ? error.message : String(error)}</pre>
        </details>
      </div>
    );
  }
};

// Initialize MSAL when the app loads
initializeMsal();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
